import React from "react";
import alienMint from "../Pictures/alien-emoji.png";
import clocksvg from "../Pictures/clocksvg.svg";

function MintBox6({ mintCount1, setMintCount1 }) {
  return (
    <div className="shop-mint-box">
      <div className="shop-mint">
        <div className="shop-mint-1st-block">
          <img className="alien-mint-pic" alt="" src={alienMint} />
          <div className="mint-state">
            <img className="mint-state-clock-svg" src={clocksvg} alt="" />
            ONGOING
          </div>
        </div>

        <div className="shop-mint-2nd-block">
          <div>
            <div className="important-text">Cauldrons</div>
            <div className="small-detail-text"> 700/700 </div>
          </div>
          <div>36$ELXR</div>
        </div>

        <div className="shop-mint-3rd-block">
          <div className="count-system">
            <button
              className="count-button"
              onClick={() => {
                mintCount1 < 10 && setMintCount1(mintCount1 + 1);
              }}
            >
              +
            </button>
            <div> {mintCount1} </div>
            <button
              className="count-button"
              onClick={() => {
                mintCount1 > 1 && setMintCount1(mintCount1 - 1);
              }}
            >
              -
            </button>
          </div>
          <div>
            <button className="mint-button">Mint✨</button>
          </div>
        </div>
      </div>
    </div>
  );
}

export default MintBox6;
